import React, { useState } from 'react'
import { img } from '../assets/assets'

const Contact = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    return (
        <>
            <div className="overflow-hidden">
                {/* <!-- <div className="bg-dark py-10">
            <div className="container">
                <div
                    className="text-center
                    d-flex
                    justify-content-between
                    space-x-10
                    align-items-center">
                    <div className="space-x-10 d-flex align-items-center">
                        <lottie-player
                            src="https://assets6.lottiefiles.com/private_files/lf30_kqshlcsx.json"
                            background="transparent"
                            speed="2"
                            style="width: 50px; height: 50px"
                            loop
                            autoplay></lottie-player>
                        <p className="color_white">
                            Dark mode is now
                            <span style="color: rgb(0, 255, 170)">Available </span>
                        </p>
                    </div>

                    <div className="mode_switcher space-x-10">
                        <a href="#" className="light d-flex align-items-center is_active">
                            <i className="ri-sun-fill"></i> Light
                        </a>
                        <a href="#" className="dark d-flex align-items-center">
                            <i className="ri-moon-fill"></i> Dark
                        </a>
                    </div>
                </div>
            </div>
        </div> --> */}

                <header className="header__1 js-header" id="header">
                    <div className="container">
                        <div className="wrap js-header-wrapper">
                            <div className="header__logo">
                                <a className="color_black" href="/">
                                    <img
                                        src={img.logos_seducetoken}
                                        alt="logo"
                                        id="logo_js_f"
                                    />
                                </a>
                            </div>

                            {/* <!-- ==================  --> */}
                            <div className="header__menu">
                                <ul className="d-flex space-x-20">
                                    <li className="has_popup">
                                        <a className="color_black" href="/">
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/about"
                                        >
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a className="color_black" href="/team">
                                            Our Team
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="../assets/img/docs/whitepaper.pdf"
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/ambassador"
                                        >
                                            Ambassadors
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/contact"
                                        >
                                            Contact
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            {/* <!-- ================= --> */}
                            <div className="header__btns">
                                <a
                                    className="btn btn-grad btn-sm"
                                    href="/dashboard"
                                >
                                    <img
                                        src={img.icons_settings}
                                        alt="Dashboard"
                                        height="20px"
                                        width="20px"
                                    />
                                    Dashboard
                                </a>
                            </div>

                            <div
                                className="header__burger js-header-burger"
                                onClick={() =>
                                    setShowMobileMenu(!showMobileMenu)
                                }
                            ></div>
                            {showMobileMenu ? (
                                <div className="header__mobile js-header-mobile">
                                    <div className="header__mobile__menu space-y-40">
                                        <ul className="d-flex space-y-20">
                                            <li className="has_popup">
                                                <a
                                                    className="color_black"
                                                    href="/"
                                                >
                                                    Home
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/about"
                                                >
                                                    About Us
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/team"
                                                >
                                                    Our Team
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/roadmap"
                                                >
                                                    Roadmap
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="../assets/img/docs/whitepaper.pdf"
                                                >
                                                    Whitepaper
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/ambassador"
                                                >
                                                    Ambassadors
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/contact"
                                                >
                                                    Contact
                                                </a>
                                            </li>
                                        </ul>
                                        <div className="space-y-20">
                                            <a
                                                className="btn btn-grad btn-sm"
                                                href="/dashboard"
                                            >
                                                Dashboard
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </header>

                <div className="requests">
                    <div className="container">
                        <div className="row gx-5 justify-content-center">
                            <div className="col-lg-8 col-md-10 requests__content">
                                <div className="requests__wrap space-y-20">
                                    {/* <!-- <div>
                                <h1 className="text-left">Get in touch with us!</h1>
                            </div> --> */}
                                    <div className="space-y-20">
                                        <h1 className="text-center">
                                            Get in touch with us!
                                        </h1>
                                        <p className="contact__desc text-center">
                                            We’re here to help and answer any
                                            questions you might have.
                                            <br />
                                            CEO: ceo@seducetokenbsc.com.
                                            <br />
                                            Marketing & Partnerships:
                                            marketing@seducetokenbsc.com.
                                            <br />
                                            Media: media@seducetokenbsc.com.
                                        </p>
                                    </div>
                                    {/* <!-- <div className="box is__big">
                            <div className="space-y-20 mb-0">
                                <div className="space-y-10">
                                    <span className="nameInput">Full Name</span>
                                    <input type="text" className="form-control" placeholder="Afan Khan">
                                </div>
                                <div className="space-y-10">
                                    <span className="nameInput">Your email address</span>
                                    <input type="email" className="form-control" placeholder="ceo@seducetokenbsc.com">
                                </div>
                                <div className="space-y-10">
                                    <span className="nameInput">Select a Subject</span>
                                    <select className="form-select
                                            custom-select" aria-label="Default
                                            select example">

                                        <option>Service Request</option>
                                        <option>NFT items</option>
                                        <option>Wallet</option>
                                        <option>Purchase</option>
                                        <option>Support</option>
                                    </select>
                                </div>
                                <div className="space-y-10">
                                    <span className="nameInput">Description</span>
                                    <textarea style="min-height: 110px" className="mb-0">
                                        </textarea>
                                    <p>Please enter the details of your request. A
                                        member of our support staff will respond as
                                        soon as possible.</p>
                                </div>
                                <div className="requests_footer">
                                    <div>
                                        <a href="dashboard.html" className="btn
                                                btn-grad">Submit message</a>
                                    </div>
                                </div>
                            </div>
                        </div> --> */}
                                </div>
                            </div>
                            {/* <!-- <div className="col-lg-4 contact__img">
                    <div className="img__wrap">
                        <img src="assets/img/bg/illustration2.png" alt="">
                    </div>
                </div> --> */}
                        </div>
                    </div>
                </div>
                <footer className="footer__1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 space-y-20">
                                <div className="footer__logo">
                                    <a href="/">
                                        <img
                                            src={img.logos_seducetoken}
                                            alt="logo"
                                            id="logo_js_f"
                                        />
                                    </a>
                                </div>

                                <div>
                                    <ul className="footer__social space-x-10 mb-40">
                                        <li>
                                            <a href="https://instagram.com/seduce_token_official?utm_medium=copy_link">
                                                <i className="ri-instagram-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/seducetokenbsc">
                                                <i className="ri-twitter-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://discord.gg/ewekBsfU4B">
                                                <i className="ri-discord-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://t.me/seducetokenofficial">
                                                <i className="ri-telegram-line"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Project</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/"> Home </a>
                                    </li>
                                    <li>
                                        <a href="/about">About us</a>
                                    </li>
                                    <li>
                                        <a href="/team"> Our Team</a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/ambassador">Ambassadors</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Get help</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/contact">Contact Us</a>
                                    </li>
                                    <li>
                                        <a href="/dashboard" target="_blank">
                                            Buy Token
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Documents</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a
                                            href="../assets/img/docs/whitepaper.pdf"
                                            target="_blank"
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p className="copyright text-center">
                            © Seduce Token 2021. Created with love by
                            <a
                                href="https://theclusterco.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                TheCluster
                            </a>
                            .
                        </p>
                    </div>
                </footer>
            </div>
        </>
    )
}

export default Contact
